"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  arraySchema: () => arraySchema,
  booleanSchema: () => booleanSchema,
  dictSchema: () => dictSchema,
  enumSchema: () => enumSchema,
  geometrySchema: () => geometrySchema,
  integerSchema: () => integerSchema,
  nullableSchema: () => nullableSchema,
  numberSchema: () => numberSchema,
  pointSchema: () => pointSchema,
  productSchema: () => productSchema,
  stringSchema: () => stringSchema,
  sumSchema: () => sumSchema,
  timestampSchema: () => timestampSchema,
  tupleSchema: () => tupleSchema,
  unknownSchema: () => unknownSchema,
  uuidSchema: () => uuidSchema
});
module.exports = __toCommonJS(create_exports);
const booleanSchema = { type: "Boolean" };
const integerSchema = { type: "Integer" };
const numberSchema = { type: "Number" };
const stringSchema = { type: "String" };
const uuidSchema = { type: "Uuid" };
const timestampSchema = { type: "Timestamp" };
function geometrySchema(geometryType) {
  return geometryType == null ? { type: "Geometry" } : { type: "Geometry", geometryType };
}
const pointSchema = geometrySchema("Point");
const unknownSchema = { type: "Unknown" };
function enumSchema(source) {
  const values = Array.isArray(source) ? source : source.values;
  return { type: "Enum", values };
}
function nullableSchema(param) {
  return { type: "Nullable", param };
}
function arraySchema(param) {
  return { type: "Array", param };
}
function tupleSchema(items) {
  return { type: "Tuple", items };
}
function dictSchema(key, value) {
  return { type: "Dict", key, value };
}
function productSchema(fields) {
  return { type: "Product", fields };
}
function sumSchema(products) {
  return { type: "Sum", products };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  arraySchema,
  booleanSchema,
  dictSchema,
  enumSchema,
  geometrySchema,
  integerSchema,
  nullableSchema,
  numberSchema,
  pointSchema,
  productSchema,
  stringSchema,
  sumSchema,
  timestampSchema,
  tupleSchema,
  unknownSchema,
  uuidSchema
});
//# sourceMappingURL=create.js.map
